class IaLiveSearch extends HTMLElement {
  constructor () {
    super()
    this.searchTimeout = null
    this.currentSearchTerm = ''
  }

  connectedCallback () {
    this.clearBtn = this.querySelector('[data-search-clear]')
    this.input = this.querySelector('[data-predictive-search-input]')
    this.form = this.querySelector('form')
    this.resultsContainer = this.querySelector('[data-predictive-search-results]')
    this.initialStateContainer = this.querySelector('[data-search-initial-state]')
    this.preloader = this.querySelector('[data-search-preloader]')
    if (!this.input || !this.form) return


    // Clear button - just clear input and show initial results
    this.clearBtn?.addEventListener('click', (e) => {
      // Prevent all event propagation
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()

      // Clear input and show initial results
      this.clearInput()

      // Return false to ensure no other handlers run
      return false
    })

    // Handle all suggestion clicks through event delegation
    this.addEventListener('click', (e) => {
      const suggestionBtn = e.target.closest('[data-search-suggestion]')
      if (suggestionBtn) {
        e.preventDefault()
        e.stopPropagation()
        this.input.value = suggestionBtn.textContent.trim()
        this.input.dispatchEvent(new Event('input'))
      }
    })

    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.form.submit()
      }
    })

    // Input handling with debounce
    this.input.addEventListener('input', () => {
      console.log('input')
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        const term = this.input.value.trim()
        console.log('term', term)
        // Only fetch if we have a term and it's different from current
        if (term && term !== this.currentSearchTerm) {
          this.currentSearchTerm = term
          this.clearBtn.classList.remove('ia-hidden')
          console.log('fetching')
          this.preloader.classList.remove('ia-hidden')
          this.resultsContainer.classList.add('ia-hidden')
          this.initialStateContainer.classList.add('ia-hidden')
          this.fetchResults(term)
            .then(success => {
              if (success) {
                this.hideInitialState()
                console.log('search success')
              }
            })
            .catch(error => {
              console.error('Error in search:', error)
              this.showInitialState()
            })
            .finally(() => {
              this.preloader.classList.add('ia-hidden')
              console.log('search finally')
            })
        } else if (!term) {
          this.currentSearchTerm = ''
          this.showInitialState()
        }
      }, 300)
    })

  }

  clearInput () {
    this.input.value = ''
    this.currentSearchTerm = ''
    this.clearBtn.classList.add('ia-hidden')
    this.input.focus()
    this.showInitialState()
  }

  showInitialState () {
    if (this.initialStateContainer) {
      this.initialStateContainer.classList.remove('ia-hidden')
      this.resultsContainer.innerHTML = ''
      this.resultsContainer.classList.add('ia-hidden')
    }
  }

  hideInitialState () {
    if (this.initialStateContainer) {
      this.initialStateContainer.classList.add('ia-hidden')
    }
    this.resultsContainer.classList.remove('ia-hidden')
  }


  async fetchResults (searchTerm) {
    if (!this.resultsContainer || !searchTerm) return false

    const url = new URL(`${window.location.origin}/search/suggest`)
    url.searchParams.set('q', searchTerm.trim())
    url.searchParams.set('resources[type]', 'product,query')
    url.searchParams.set('resources[limit]', '5')
    url.searchParams.set('resources[limit_scope]', 'each')
    url.searchParams.set('section_id', 'ia-ajax-search-results')

    try {
      const response = await fetch(url.toString())
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      if (!html) {
        throw new Error('Empty response received')
      }

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')
      const resultsSection = doc.getElementById('shopify-section-ia-ajax-search-results')

      if (!resultsSection) {
        throw new Error('Results section not found in response')
      }

      // Only update if the search term hasn't changed
      if (searchTerm === this.currentSearchTerm) {
        this.resultsContainer.innerHTML = resultsSection.innerHTML
        return true
      }
      return false
    } catch (error) {
      console.error('Search error:', { error, searchTerm, url: url.toString() })
      return false
    }
  }
}

customElements.define('ia-live-search', IaLiveSearch)
